import React from 'react';
import { RouteProps } from 'react-router-dom';
import {
	companyPagesMenu,
	componentPagesMenu,
	dashboardPagesMenu,
	demoPagesMenu,
	talentPagesMenu,
	talentSettingsMenu,
	gettingStartedPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../menu';

// import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import DashboardBookingHeader from '../pages/_layout/_headers/DashboardBookingHeader';
import ProfilePageHeader from '../pages/_layout/_headers/ProfilePageHeader';
import SummaryHeader from '../pages/_layout/_headers/SummaryHeader';
import ProductsHeader from '../pages/_layout/_headers/ProductsHeader';
import ProductListHeader from '../pages/_layout/_headers/ProductListHeader';
import PageLayoutHeader from '../pages/_layout/_headers/PageLayoutHeader';
import ComponentsHeader from '../pages/_layout/_headers/ComponentsHeader';
import FormHeader from '../pages/_layout/_headers/FormHeader';
import ChartsHeader from '../pages/_layout/_headers/ChartsHeader';
import ContentHeader from '../pages/_layout/_headers/ContentHeader';
import UtilitiesHeader from '../pages/_layout/_headers/UtilitiesHeader';
import IconHeader from '../pages/_layout/_headers/IconHeader';
// import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';
import DocumentationHeader from '../pages/_layout/_headers/DocumentationHeader';
import SimpleHeader from '../pages/_layout/_headers/SimpleHeader';

const headers: RouteProps[] = [
	// Company Dashboard Routes
	{ path: companyPagesMenu.dashboard.path, element: <SimpleHeader /> },

	// Company Organizations Edit Route (kept for edit functionality)
	{ path: 'company/organizations/edit/:organizationId', element: <SimpleHeader /> },

	// Company Finance Routes
	{ path: companyPagesMenu.Finance.subMenu.invoices.path, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Finance.subMenu.invoices.invoiceDetailPaath,
		element: <SimpleHeader />,
	},

	// Company Talents Routes
	{ path: companyPagesMenu.Talents.subMenu.aiSearch.path, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Talents.subMenu.aiSearch.talentsProfilePath,
		element: <SimpleHeader />,
	},
	{ path: companyPagesMenu.Talents.subMenu.myTalent.path, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Talents.subMenu.classicSearch.path, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Talents.subMenu.savedSearches.path, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Talents.subMenu.savedSearches.detailPath, element: <SimpleHeader /> },

	// Company Projects Routes
	{ path: companyPagesMenu.Projects.path, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Projects.subMenu.projects.detailPath, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Projects.subMenu.projects.createProjectPath,
		element: <SimpleHeader />,
	},
	{ path: companyPagesMenu.Projects.subMenu.projects.editProjectPath, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Projects.subMenu.projects.addInternalMemberPath,
		element: <SimpleHeader />,
	},
	{
		path: companyPagesMenu.Projects.subMenu.projects.assignProjectToExternalPath,
		element: <SimpleHeader />,
	},

	// Company Milestones Routes
	{ path: companyPagesMenu.Projects.subMenu.projects.milestonesPath, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Projects.subMenu.projects.createMilestonePath,
		element: <SimpleHeader />,
	},
	{
		path: companyPagesMenu.Projects.subMenu.projects.milestoneDetailPath,
		element: <SimpleHeader />,
	},

	// Company Timesheets Routes
	{ path: companyPagesMenu.Projects.subMenu.projects.timesheetsPath, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Projects.subMenu.projects.timesheetDetailPath,
		element: <SimpleHeader />,
	},

	// Company Quotes Routes
	{ path: companyPagesMenu.Legal.subMenu.quotes.path, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Legal.subMenu.quotes.requestsPath, element: <SimpleHeader /> },
	{ path: companyPagesMenu.Legal.subMenu.quotes.detailPath, element: <SimpleHeader /> },

	// Company Contracts Routes
	{ path: companyPagesMenu.Legal.path, element: <SimpleHeader /> },
	{
		path: companyPagesMenu.Legal.subMenu.contracts.createContractPath,
		element: <SimpleHeader />,
	},
	{
		path: companyPagesMenu.Legal.subMenu.contracts.path,
		element: <SimpleHeader />,
	},
	{
		path: companyPagesMenu.Legal.subMenu.contracts.detailPath,
		element: <SimpleHeader />,
	},

	// Talent Dashboard Routes
	{ path: talentPagesMenu.dashboard.path, element: <SimpleHeader /> },

	// Talent Projects Routes
	{ path: talentPagesMenu.Work.subMenu.projects.path, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.projectDetailPath, element: <SimpleHeader /> },

	// Talent Milestones Routes
	{ path: talentPagesMenu.Work.milestonesPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.milestoneDetailPath, element: <SimpleHeader /> },

	// Talent Timesheets Routes
	{ path: talentPagesMenu.Work.timesheetsPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.timesheetDetailPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.createTimesheetPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.updateTimesheetPath, element: <SimpleHeader /> },
	// Talent Subscription Routes
	{ path: talentSettingsMenu.subscription.path, element: <SimpleHeader /> },
	// Talent Settings Routes
	{ path: talentSettingsMenu.profile.path, element: <SimpleHeader /> },
	{ path: talentSettingsMenu.billing.path, element: <SimpleHeader /> },

	// Talent Finance Routes
	{ path: talentPagesMenu.Finance.path, element: <SimpleHeader /> },
	{
		path: talentPagesMenu.Finance.invoiceDetailPath,
		element: <SimpleHeader />,
	},

	// Talent Quotes Routes
	{ path: talentPagesMenu.Work.subMenu.quotes.path, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.requestsPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.createPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.editPath, element: <SimpleHeader /> },
	{ path: talentPagesMenu.Work.detailPath, element: <SimpleHeader /> },

	// Talent Messages Routes
	{ path: talentPagesMenu.Clients.subMenu.messages.path, element: <SimpleHeader /> },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: demoPagesMenu.login.path, element: null },
	{ path: demoPagesMenu.signUp.path, element: null },
	{ path: demoPagesMenu.page404.path, element: <SimpleHeader /> },
	{ path: demoPagesMenu.knowledge.subMenu.grid.path, element: null },
	{ path: dashboardPagesMenu.dashboard.path, element: <SimpleHeader /> },
	{
		path: demoPagesMenu.projectManagement.subMenu.list.path,
		element: <SimpleHeader />,
	},
	{ path: demoPagesMenu.pricingTable.path, element: <SimpleHeader /> },
	{
		path: dashboardPagesMenu.dashboardBooking.path,
		element: <DashboardBookingHeader />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.calendar.path,
		element: <DashboardBookingHeader />,
	},
	{
		path: demoPagesMenu.appointment.subMenu.employeeList.path,
		element: <DashboardBookingHeader />,
	},
	{
		path: demoPagesMenu.listPages.subMenu.listFluid.path,
		element: <DashboardBookingHeader />,
	},
	{
		path: `${demoPagesMenu.editPages.path}/*`,
		element: <DashboardBookingHeader />,
	},
	{
		path: `${demoPagesMenu.appointment.subMenu.employeeID.path}/*`,
		element: <DashboardBookingHeader />,
	},
	{
		path: `${demoPagesMenu.projectManagement.subMenu.itemID.path}/*`,
		element: <DashboardBookingHeader />,
	},
	{
		path: demoPagesMenu.singlePages.subMenu.fluidSingle.path,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.singlePages.subMenu.boxedSingle.path,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.sales.subMenu.transactions.path,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.chat.subMenu.withListChat.path,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.chat.subMenu.onlyListChat.path,
		element: <ProfilePageHeader />,
	},
	{
		path: `${demoPagesMenu.knowledge.subMenu.itemID.path}/:id`,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.crm.subMenu.dashboard.path,
		element: <ProfilePageHeader />,
	},
	{
		path: demoPagesMenu.crm.subMenu.customersList.path,
		element: <ProfilePageHeader />,
	},
	{
		path: `${demoPagesMenu.crm.subMenu.customerID.path}/:id`,
		element: <ProfilePageHeader />,
	},
	{
		path: dashboardPagesMenu.summary.path,
		element: <SummaryHeader />,
	},
	{
		path: demoPagesMenu.gridPages.subMenu.gridBoxed.path,
		element: <ProductsHeader />,
	},
	{
		path: demoPagesMenu.gridPages.subMenu.gridFluid.path,
		element: <ProductsHeader />,
	},
	{
		path: demoPagesMenu.listPages.subMenu.listBoxed.path,
		element: <ProductListHeader />,
	},
	{
		path: demoPagesMenu.sales.subMenu.salesList.path,
		element: <ProductListHeader />,
	},
	{
		path: demoPagesMenu.sales.subMenu.productsGrid.path,
		element: <ProductListHeader />,
	},
	{
		path: `${demoPagesMenu.sales.subMenu.productID.path}/:id`,
		element: <ProductListHeader />,
	},
	{
		path: `${pageLayoutTypesPagesMenu.asideTypes.path}/*`,
		element: <PageLayoutHeader />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PageLayoutHeader />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PageLayoutHeader />,
	},
	{
		path: `${componentPagesMenu.components.path}/*`,
		element: <ComponentsHeader />,
	},
	{
		path: `${componentPagesMenu.forms.path}/*`,
		element: <FormHeader />,
	},
	{
		path: `${componentPagesMenu.charts.path}/*`,
		element: <ChartsHeader />,
	},
	{
		path: `${componentPagesMenu.content.path}/*`,
		element: <ContentHeader />,
	},
	{
		path: `${componentPagesMenu.utilities.path}/*`,
		element: <UtilitiesHeader />,
	},
	{
		path: `${componentPagesMenu.icons.path}/*`,
		element: <IconHeader />,
	},
	{
		path: `${gettingStartedPagesMenu.gettingStarted.path}/*`,
		element: <DocumentationHeader />,
	},
	{
		path: `${gettingStartedPagesMenu.routes.path}/*`,
		element: <DocumentationHeader />,
	},
	{
		path: `*`,
		element: <SimpleHeader />,
	},
];

export default headers;
